import TranslationText from '@Components/Utilities/TranslationText';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { SandhillsSlickSlider, Panel } from '@Components/Shared/SandhillsSlickSlider';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';


const PopularBrands = (props) => {

    const windowSize = useWindowSize();
    const currentSite = useRecoilValue(atoms.currentWebsite);
     
    return (props && props.Cards &&
        (!windowSize.isMobile && props.Cards.length > 6) ?
            <SandhillsSlickSlider ShowSection {...props}>
                {props.Cards.map(card =>
                    <Panel key={`brand-slider-${card.Url}`} PanelType={props.ChildComponent} PanelClass={props.PanelClass} {...card} />)}
            </SandhillsSlickSlider> :
            <section className='popular-brands-section'>
                <h2 className='section-title'>
                <span className='section-title-text'>{currentSite?.Site?.IsAuctionValues ? "" : props.Title}</span>
                </h2>
                <div className='popular-brands-container'>
                    {props.Cards.map(brand =>
                        <a key={`brand-${brand.Url}`} href={brand.Url} aria-label={brand.Name} className={'brand' + ((windowSize.isMobile || brand.Bordered) ? ' bordered' : '')}>
                            <div className='content'>
                                <div className='image-wrapper'>
                                    <LazyLoadImage className='listing-image' src={brand.ImgUrl} alt="" />
                                </div>
                                <h3>
                                    <div className='view-listing-details-link des-view-listingDetails'>
                                        <strong dangerouslySetInnerHTML={{ __html: brand.Text }}></strong>
                                    </div>
                                </h3>
                            </div>
                        </a>)}
                </div>
            </section>
    );
};

export default PopularBrands;